/** Pick the tool that best matches a user message by keyword overlap with the
 *  tool's name + description. Used by the SIMULATED preview paths so the fake
 *  "⚙ Used <tool>" trace shows a plausible tool instead of always tools[0].
 *  Falls back to the first tool when nothing matches. */
export function pickToolForMessage<T extends { name: string; description?: string }>(
  tools: T[],
  message: string,
): T | undefined {
  if (!tools.length) return undefined;
  const words = message
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .filter((w) => w.length > 2);
  let best: T | undefined;
  let bestScore = 0;
  for (const tool of tools) {
    const haystack = `${tool.name} ${tool.description ?? ''}`.toLowerCase();
    let score = 0;
    for (const w of words) {
      if (haystack.includes(w)) score++;
    }
    if (score > bestScore) {
      best = tool;
      bestScore = score;
    }
  }
  return best ?? tools[0];
}
